import { StrictMode, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { AuthErrorCodes } from 'firebase/auth';

import { AuthContextProvider } from './auth/auth-context-provider';
import { AuthorisedApolloProvider } from './apollo-provider';
import { FullPageLoaderProvider } from './components/loader';
import { initPrintLayoutListeners } from './lib/print';
import { initPreloadErrorListener } from './lib/preload-error';
import App from './App';

initPrintLayoutListeners();
initPreloadErrorListener();

const enableSentry = import.meta.env.PROD;
if (enableSentry) {
  Sentry.init({
    dsn: 'https://550a94ba9ef04240956a34dd514f660c@o1090854.ingest.sentry.io/6291300',
    release: APP_VERSION,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],

    tracesSampleRate: 1.0,
    // This should come from import.meta.env but since we currently have no means to create separate builds
    // it is hardcoded for now.
    environment: 'production',
    ignoreErrors: [AuthErrorCodes.POPUP_CLOSED_BY_USER, AuthErrorCodes.USER_CANCELLED],
  });
  Sentry.setContext('Supersimple', {
    Client: `Supersimple-app ${APP_VERSION}`,
  });
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <FullPageLoaderProvider>
      <AuthContextProvider>
        <AuthorisedApolloProvider>
          <App />
        </AuthorisedApolloProvider>
      </AuthContextProvider>
    </FullPageLoaderProvider>
  </StrictMode>,
);
